export const engagementCampaignsAppGroupIdSearchable = "/engagement/campaigns/:app_group_id/searchable";

/**
 * Default page size when a caller omits `limit`. Mirrors the backend default; sending this
 * (rather than 0) keeps the request bounded — the backend treats limit=0 as "no limit".
 */
export const searchableCampaignsDefaultLimit = 50;
